<template>
    <el-form :inline="true" :model="form" class="form" size="small" @submit.native.prevent>
        <slot></slot>
        <el-form-item>
            <el-button plain type="primary" icon="el-icon-search" @click="doSearch" native-type="submit" :disabled="disabled">
                {{$t('form.search')}}
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        name: 'zk-search-form-inline',
        props: {
            form: {
                default: {}
            },
            disabled: null
        },
        methods: {
            doSearch() {
                this.$emit('search', this.form)
            }
        }
    }
</script>

<style scoped>
    .form {
        padding:4px;
    }

    /deep/ .el-form-item {
        margin: 3px;
    }
    @media (max-width: 767px) {
       /deep/ .el-date-editor--datetimerange.el-input,   /deep/ .el-date-editor--datetimerange.el-input__inner{
            width: 200px !important;
        }

    }
    @media (max-width: 992px) {
        /deep/.el-date-editor--datetimerange.el-input,  /deep/  .el-date-editor--datetimerange.el-input__inner{
            width: 200px !important;
        }
    }
</style>
